// import useGetWhoAmI from "../aorta/use-get-who-am-i";
import { deleteArchiveBusinessReceipt } from "apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getAllQueuesQuery } from "./get-all-queues";
import { getAppointmentsQueryName } from "./get-appointments";

export default function useDeleteReceipt() {
  const queryClient = useQueryClient();

  return useMutation(deleteArchiveBusinessReceipt, {
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries(getAppointmentsQueryName({})),
      ]),
  });
}
